// extracted by css-extract-rspack-plugin
export default {"paymentRequestSendErrorBanner":"paymentRequestSendErrorBanner-vtES4D"};